import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CustomOrder from "../pages/custom-order/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/monte-seu-pedido",
    element: <CustomOrder />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
